import { defineFcm } from '../shared/factory';

export const FCM_GROWTH_BONUS_IMPRESSION_VALUE_UI = defineFcm('growth_bonus_impression_value_ui')
	.asBoolean()
	.withDefault(false)
	.toConfig({
		owner: 'TBD',
		scope: 'TBD',
		context: 'Promotion payment form',
		description:
			'Adds UI to show the amount of additional impressions gained when countries have bonus impressions configured',
		import: false,
		deprecated: 'No references found. Safe to delete after 2026-09-01.',
	});
